<template>
    <div class="fill-height d-flex" style="overflow-x: hidden">

        <div class="d-flex align-center justify-center fill-height flex-grow-1" v-if="loadingSites">
            <app-centre-loader label="Loading Sites"></app-centre-loader>
        </div>

        <template v-else>
            <v-expand-x-transition>
                <div class="px-2 fill-height of-y flex-grow-1 flex-equal" style="max-width: 35%">
                    <template v-for="site in filteredSites">
                        <div class="pa-2">
                            <v-card
                                    class="d-flex align-center"
                                    :key="site._id"
                                    @click.self="selectedSite = selectedSite === site ? null : site"
                                    :raised="selectedSite === site"
                                    hover
                            >
                                <div class="ml-2" @click.self="selectedSite = selectedSite === site ? null : site">
                                    <template v-if="selectedSite === site">
                                        <v-icon color="primary">mdi-check-circle</v-icon>
                                    </template>
                                    <template v-else>
                                        <v-icon color="grey">mdi-checkbox-blank-circle-outline</v-icon>
                                    </template>
                                </div>

                                <div class="subtitle-1 font-weight-light flex-grow-1 flex-equal pa-2 text-truncate" @click.self="selectedSite = selectedSite === site ? null : site">
                                    {{site.name}}
                                </div>


<!--                                <div v-if="user.adminSiteId !== $store.state.curSiteId" class="pr-3">-->
<!--                                    <v-tooltip top>-->
<!--                                        <template v-slot:activator="{on}">-->
<!--                                            <v-icon-->
<!--                                                    v-on="on"-->
<!--                                            >-->
<!--                                                mdi-shield-alert-->
<!--                                            </v-icon>-->
<!--                                        </template>-->
<!--                                        Limited Access-->
<!--                                    </v-tooltip>-->
<!--                                </div>-->
                            </v-card>
                        </div>
                    </template>
                </div>
            </v-expand-x-transition>

                    <v-slide-x-reverse-transition>
                        <div v-if="selectedSite" class="fill-height" style="width: 65%">
                            <app-partner-site-side-bar
                                    :selected-site="selectedSite"
                                    ref="sidebar"
                                    @partnerUpdated="selectedSite.partner = $event"
                            />
<!--                            TODO Add Here-->
<!--                            @checkSelected="checkSelectedUserTab"-->
                        </div>
                    </v-slide-x-reverse-transition>
        </template>
    </div>
</template>

<script>
import AppList from "@/components/Shared/AppList/AppList";
import {mergeRecursive, nameSort} from "@/core/codeFunctions";
import AppCentreLoader from "@/components/Shared/AppCentreLoader";
import AppPartnerSiteSideBar from "@/components/Partner/AppPartnerSiteSideBar";

export default {
    components: {AppPartnerSiteSideBar, AppCentreLoader},
    data() {
        return {
            loadingSites: false,
            sites: null,
            selectedSite: null
        }
    },
    watch: {
    },
    created() {
    },
    beforeUnmount() {
    },
    mounted() {
        this.loadPartnerSites();
    },
    methods: {
        async loadPartnerSites() {
            try {
                this.loadingSites = true;
                this.sites = await this.$newReq('GET', `partner/sites/startup`)
            } catch (e) {
                this.$snack.netWorkError()
                console.log(e)
            } finally {
                this.loadingSites = false
            }

        },
    },


    computed: {

        filterStr() {
            return this.$store.state.ref.partner.sites.filterStr
        },

        filteredSites() {
            return (this.sites || [])
                    .filter(site => this.filterStr ? JSON.stringify(site).toLowerCase().includes((this.filterStr || '').toLowerCase()) : true)
                    .sort(nameSort)
        }

    },
}
</script>

<style scoped>

</style>